import Modifier from 'ember-modifier';
import { registerDestructor } from '@ember/destroyable';

const createResizeObserver = () => {
  const elementMap = new WeakMap();

  const entriesIterator = ({ target, contentRect }) => {
    elementMap.get(target)?.(contentRect);
  };

  const observer = new ResizeObserver((entries) => {
    entries.forEach(entriesIterator);
  });

  return {
    observe(element, callback) {
      elementMap.set(element, callback);
      observer.observe(element);

      return () => {
        observer.unobserve(element);
        elementMap.delete(element);
      };
    },
  };
};

const cleanup = (instance) => {
  instance.unobserve();
  instance.callback(null);
};

class ResizeObserverModifier extends Modifier {
  static observer = null;

  unobserve = null;
  callback = null;

  get resizeObserver() {
    return (ResizeObserverModifier.observer ??= createResizeObserver());
  }

  constructor() {
    super(...arguments);
    registerDestructor(this, cleanup);
  }

  modify(element, [callback]) {
    this.callback = callback;

    this.unobserve ??= this.resizeObserver.observe(element, (boxSize) => {
      this.callback(boxSize);
    });
  }
}

export default ResizeObserverModifier;
